import axios from 'axios';
import { BACKEND } from '../../config/configEnvs';

const ActualizarEstadoUsuario = async (userId, newStatus) => {
    try {
      await axios.put(`${BACKEND}/api/registroLeads/${userId}`, { status: newStatus });
    } catch (error) {
      return false
    }
};

export default ActualizarEstadoUsuario;
